import React from 'react';
import {createStyles, makeStyles, Theme, withStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import {StepIconProps} from '@material-ui/core/StepIcon';
import {IRoutingPoints} from "./ShipmentList";
import {Avatar, Typography} from '@material-ui/core';
import {Flag} from '@material-ui/icons';
import {useTranslation} from "react-i18next";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const HorizontalConnector = withStyles({
    alternativeLabel: {
        top: 13,
    },
    active: {
        '& $line': {
            backgroundColor: "#3bb325"
        },
    },
    completed: {
        '& $line': {
            backgroundColor: "#3bb325"

        },
    },
    line: {
        height: 5,
        border: 0,
        backgroundColor: '#999999',
        borderRadius: 1,
    },
})(StepConnector);

const VerticalConnector = withStyles({
    active: {
        '& $line': {
            backgroundColor: "#3bb325"
        },
    },
    completed: {
        '& $line': {
            backgroundColor: "#3bb325"

        },
    },
    line: {
        width: 5,
        // border: 0,
        backgroundColor: '#999999',
        // borderRadius: 1,
    },
    vertical: {
        padding: 0,
    }
})(StepConnector);


const useColorlibStepIconStyles = makeStyles({
    root: {
        zIndex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        "& .MuiAvatar-root": {
            backgroundColor: "#434343",
            border: "2px solid #353535",
            width: 30,
            height: 30,
        }

    },

    completed: {
        "& .MuiAvatar-root": {
            backgroundColor: "#3bb325",
            border: "2px solid #689627"
        }
    },
    active: {},
});

function ColorlibStepIcon(props: StepIconProps) {
    const classes = useColorlibStepIconStyles();
    const {active, completed, icon} = props;


    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icon === 1 ? <Avatar><Flag/></Avatar> : <Avatar>{""}</Avatar>}
        </div>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            display: "flex",

            justifyContent: "center",
            alignItems: "center",
            marginTop: 30,
            marginBottom: 30,
            "& .MuiStepper-root": {
                flex: 1,
                padding: 0,
                backgroundColor: "transparent"
            },
            "& .MuiStepLabel-labelContainer": {
                // display: "none"
            }
        },
        button: {
            marginRight: theme.spacing(1),
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
    }),
);


type RoutingPointsStepperProps = {
    routingPoints: IRoutingPoints[]
    isVertical?: boolean
};


const RoutingPointsStepper: React.FC<RoutingPointsStepperProps> = ({routingPoints, isVertical}) => {


    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [visibleRoutingPoints, setVisibleRoutingPoints] = React.useState<IRoutingPoints[]>([]);

    React.useEffect(() => {
        setActiveStep(0);
        const rps = routingPoints.filter(rp => rp.visible);
        setVisibleRoutingPoints(rps);

        rps.forEach(rp => {
            if (rp.reached) {
                setActiveStep(step => step + 1)
            }
        })
    }, [routingPoints, setActiveStep, setVisibleRoutingPoints]);


    return (
        <div className={classes.root} style={isVertical ? {flexDirection: "column"} : {flexDirection: "row"}}>
            <Stepper alternativeLabel={!isVertical} activeStep={activeStep}
                     connector={isVertical ? <VerticalConnector/> : <HorizontalConnector/>}
                     orientation={isVertical ? "vertical" : undefined}>
                {visibleRoutingPoints.map((rp, index) => {
                    const step = index + 1;
                    return <Step key={step}>
                        <StepLabel
                            optional={<DateLabel rp={rp} isVertical={isVertical}/>}
                            StepIconComponent={ColorlibStepIcon}
                        >
                            <RpLabel step={step} rpLength={visibleRoutingPoints.length} isVertical={isVertical}
                                     rp={rp}/>
                        </StepLabel>
                    </Step>
                })}
            </Stepper>

        </div>
    );
};

const DateLabel: React.FC<{ rp: IRoutingPoints, isVertical: boolean | undefined }> = ({rp, isVertical}) => {

    const {routingDate} = rp;

    if (!isVertical || !routingDate) {
        return null;
    }


    const dateString = /\d{4}-\d{2}-\d{2}/.exec(routingDate)?.toString();

    const date = dateString ? new Date(dateString) : undefined;

    const day = date?.getDate();
    const month = date ? MONTHS[date.getMonth()] : "";
    return <React.Fragment>

        <Typography variant="caption" color="textSecondary">
            {`${day}.${month}`}
        </Typography>
    </React.Fragment>
};

const RpLabel: React.FC<{ step: number, rpLength: number, rp: IRoutingPoints, isVertical: boolean | undefined }> = ({step, rpLength, isVertical, rp}) => {
    const {t} = useTranslation();


    const rpName = step === 1 || step === rpLength || !!isVertical ? t("shipment.route." + rp.routingType) : "";


    return <React.Fragment>

        <Typography>
            {rpName}
        </Typography>
    </React.Fragment>
};

export default RoutingPointsStepper;